import { joinUrlPath } from "@dx/components/utils";
import { useUser, getNavigateAsRoutePrefix } from "@dx/portal/user";
import { Remote } from "@dx/portal/remote";
import ServerErrorPage from "./error/ServerErrorPage";
import React from "react";

function App({
  isSgInternal: isSgInternalPerSsoSgmarkets,
}: {
  isSgInternal: boolean;
}) {
  const context = useUser({ isSgInternal: isSgInternalPerSsoSgmarkets });

  if (!context.user) {
    return <div className="vh-100 bg-lvl2"></div>;
  }

  const joinPublicUrlIfNeeded = (path: string) =>
    path?.includes("://")
      ? path
      : joinUrlPath(process.env.PUBLIC_URL ?? "", path ?? "");

  // what the user is shown depends on their 'audience', based on their auth-token or 'dx-navigate-as' header

  let remoteUrl = joinPublicUrlIfNeeded(
    process.env.REACT_APP_PUBLIC_PORTAL_URL ?? ""
  );

  if (context.user.audience === "int" && context.user.portalModuleBaseUrl) {
    remoteUrl = joinPublicUrlIfNeeded(context.user.portalModuleBaseUrl);
  }

  const isSgInternal =
    isSgInternalPerSsoSgmarkets || context.user?.fromInternal;

  const routeBasePath = joinUrlPath(
    process.env.PUBLIC_URL ?? "",
    getNavigateAsRoutePrefix()
  );

  return (
    <Remote
      key={routeBasePath}
      remoteUrl={joinUrlPath(remoteUrl, "remoteEntry.js")}
      scope={`dx_portal_remote${
        context.user?.audience !== "int" ? "_pub" : ""
      }`}
      module="./App"
      routeBasePath={routeBasePath}
      user={context.user}
      setNavigateAs={context.setNavigateAs}
      isSgInternal={isSgInternal}
    />
  );
}

class AppErrorBoundary extends React.Component<
  { isSgInternal: boolean },
  { error?: Error }
> {
  static getDerivedStateFromError = (error: Error) => ({ error });

  render = () => {
    if (this.state?.error) {
      console.error("%O", this.state.error);
      return <ServerErrorPage />;
    }
    return <App isSgInternal={this.props.isSgInternal} />;
  };
}

export default AppErrorBoundary;
